import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import history from 'app/routes/history';
import Isvg from 'react-inlinesvg';

import { Card, Badge } from 'reactstrap';
import { simpleDateNoTime, friendlyTime } from 'app/utils/parsers';
import HeaderThin from 'app/components/layout/HeaderThin';
import Loader from 'app/components/general/Loader';
import Button from 'app/components/general/Button';

import * as connectionActions from 'app/ducks/connections/actions';
import * as connectionTypeActions from 'app/ducks/connectionTypes/actions';
import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as connectionSelectors from 'app/ducks/connections/selectors';
import * as connectionTypeSelectors from 'app/ducks/connectionTypes/selectors';
import * as organisationSelectors from 'app/ducks/organisations/selectors';

import RunIcon from 'app/images/icons/run.svg';
import EditIcon from 'app/images/icons/edit.svg';
import ListIcon from 'app/images/icons/list.svg';

interface IConnectionsList {
  actions: any;
  organisations: any;
  organisationTags: any;
  connections: any;
  connectionTypes: any;
  groups: any;
  appReady: boolean;
}
const selector = (state): any => ({
  connections: connectionSelectors.getConnections(state),
  connectionTypes: connectionTypeSelectors.getConnectionTypes(state),
  organisations: organisationSelectors.getOrganisations(state),
  appReady: loadingSelectors.appReady(state),
});

const actionCreators = _.merge(connectionActions, connectionTypeActions);

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class ConnectionsList extends React.Component<IConnectionsList> {
  static defaultProps: IConnectionsList = {
    actions: undefined,
    organisations: undefined,
    organisationTags: undefined,
    connections: undefined,
    connectionTypes: undefined,
    groups: undefined,
    appReady: false,
  };

  componentDidMount = (): void => {
    this.props.actions.getAllConnections();
    this.props.actions.getAllConnectionTypes();
  };

  renderConnections = (): React.ReactNode => {
    if (_.isEmpty(this.props.connections.connectionsById)) {
      return <h3>You have no connections currently setup.</h3>;
    }
    return _.map(this.props.connections.connectionsById, (connection) => {
      const connectionType = this.props.connectionTypes.connectionTypesById[
        connection.connectionType.id
      ];

      const connectionStatus = connectionSelectors.parseConnectionStatus(
        connection,
      );

      if (_.isEmpty(connectionType)) {
        return null;
      }
      return (
        <Card className="no-shadow with-margin-bottom" key={connection.id}>
          <div className="row">
            <div className="col">
              <div className="connection-card-container">
                <div className="connection-icon">
                  <img alt={connectionType.name} src={connectionType.logoUrl} />
                </div>
                <div className="connection-description flex-grow-1">
                  <div className="row">
                    <div className="col">
                      <span className="medium-text text-weight-medium-bold">
                        {connection.name}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <span className="normal-text">
                        {simpleDateNoTime(connection.connectedAt)}
                      </span>
                    </div>
                  </div>
                  <div className="row with-margin-top-10">
                    <div className="col">
                      <span className="medium-text text-weight-medium-bold">
                        <Badge
                          className="connection-status-badge"
                          color={connectionStatus.colour}
                        >
                          {connectionStatus.text}
                        </Badge>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="connection-button">
                  <Button
                    onClick={() => history.push(`/connections/${connection.id}/run`)}
                    btnIcon={RunIcon}
                    className="btn-thin btn-2"
                  >
                    Run
                  </Button>
                  <Button
                    onClick={() => history.push(`/connections/${connection.id}`)}
                    btnIcon={EditIcon}
                    className="btn-thin btn-2 with-margin-top-10"
                  >
                    Manage
                  </Button>
                  <Button
                    onClick={() => history.push(`/connections/${connection.id}/runs`)}
                    btnIcon={ListIcon}
                    className="btn-thin btn-2 with-margin-top-10"
                  >
                    View Runs
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Card>
      );
    });
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Connections"
              divider
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            {this.props.connections.isLoading && (
              <div className="table-loading">
                <Loader skeleton height={25} count={5} isActive color="grey" />
              </div>
            )}
            {!this.props.connections.isLoading && this.renderConnections()}

            {/* <ConnectionsTable
              {...this.props}
              {...this.props.connections}
              selectConnection={this.props.actions.selectConnection}
            /> */}
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col text-right">
            <Button
              onClick={() => history.push('/create-connection')}
              className="btn btn-1"
            >
              Create Connection
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
